import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  Button,
  Grow,
  Paper,
  Popper,
  Typography,
  MenuList,
  MenuItem,
  ClickAwayListener,
  ListItemIcon,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import { styles } from "./styles";
import Loading from "../loading";
import Snackbar from "../snackbar";
import { sortPackageList } from "../../utils/setting";
import Module from "../pickModule/modulePackage/module";
class ServicePackage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      packages: {},
      packageList: [],
      anchorElPackage: null,
      openPackage: false,
    };
  }
  async componentDidMount() {
    const _this = this;
    let check = await this.props.getListPackage();
    if (check.code === 1) {
      let packageList = sortPackageList(check.data);
      let packages = packageList[0];
      this.setState(
        {
          packageList: packageList,
          packages: packages,
        },
        function () {
          _this.Module.handleShowModule(packages.moduleRole);
        }
      );
    }
  }

  handleClosePackage = () => {
    this.setState({ anchorElPackage: null, openPackage: false });
  };
  handleTogglePackage = (event) => {
    let { openPackage, anchorElPackage } = this.state;
    anchorElPackage = anchorElPackage ? null : event.currentTarget;
    openPackage = Boolean(anchorElPackage);
    this.setState({
      anchorElPackage: anchorElPackage,
      openPackage: openPackage,
    });
  };
  changePackage = (packages) => {
    const _this = this;
    this.setState({ packages: packages }, function () {
      _this.handleClosePackage();
      _this.Module.handleShowModule(packages.moduleRole);
    });
  };

  handleSaveModule = async () => {
    let { packages } = this.state;
    let moduleRole = this.Module.getModule();
    packages.moduleRole = moduleRole;
    this.loading.startLoading();
    let check = await this.props.updatePackage({ packages: packages });
    this.loading.stopLoading();
    if (check.code === 1) {
      this.mSnackbar.handleClick("Update Package Success");
    } else {
      this.mSnackbar.handleClick(
        `Update Package Fail: ${check.message}`,
        "error"
      );
    }
  };

  render() {
    const { classes, t } = this.props;
    let { packageList, packages, anchorElPackage, openPackage } = this.state;
    let packageName = packages ? packages.packageName : "basic";
    return (
      <React.Fragment className={classes.root}>
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />
        <Paper>
          <div className={classes.topBar}>
            <div
              className={classes.topBarLeft}
              aria-describedby="menu-list-manage-package"
              // aria-controls="menu-list-manage-package"
              aria-haspopup="true"
              onClick={this.handleTogglePackage}
            >
              <div
                className={classNames(
                  classes.packageName,
                  classes["packageName_" + packageName]
                )}
              >
                {packageName}
              </div>
              <div
                className={classNames(
                  classes.arrowPackage,
                  classes["arrowPackage_" + packageName]
                )}
              ></div>
            </div>
            <div className={classes.topBarRight}>
              <Button
                className={classes.button}
                variant="contained"
                color="primary"
                onClick={this.handleSaveModule}
              >
                {t("module_save")}
              </Button>
            </div>
          </div>
        </Paper>
        <Paper>
          <Module
            onRef={(id) => (this.Module = id)}
            // handleStatusButton={this.handleStatusButton}
          />
        </Paper>
        <Popper
          open={openPackage}
          anchorEl={anchorElPackage}
          id="menu-list-manage-package"
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper className={classes.popupPackage}>
                <ClickAwayListener onClickAway={this.handleTogglePackage}>
                  <MenuList>
                    {packageList.map((itemPackage, index) => {
                      return (
                        <MenuItem
                          key={index}
                          className={classes.menuItem}
                          onClick={() => this.changePackage(itemPackage)}
                        >
                          <ListItemIcon className={classes.rootListItemIcon}>
                            {itemPackage.packageName === "bronze" ||
                            itemPackage.packageName === "silver" ||
                            itemPackage.packageName === "gold" ? (
                              <img
                                class="package-icon"
                                src={`/images/${itemPackage.packageName}-medal.svg`}
                              />
                            ) : (
                              ""
                            )}
                          </ListItemIcon>
                          <Typography variant="inherit">
                            {itemPackage.packageName}
                          </Typography>
                        </MenuItem>
                      );
                    })}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </React.Fragment>
    );
  }
}

const mapState = (state) => ({
  setting: state.setting.setting,
});

const mapDispatch = (dispatch) => ({
  getListPackage: dispatch.packages.getListPackage,
  updatePackage: dispatch.packages.updatePackage,
  getSettings: dispatch.setting.getSettings,
  updateSettings: dispatch.setting.updateSettings,
});
export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(ServicePackage)
  )
);
